import { api } from "./client";
import { ApiError, apiError } from "./errors";
import type { components } from "./schema";

export type MeResponse = components["schemas"]["MeResponse"];
export type UserRole = components["schemas"]["UserRole"];

export async function getMe(): Promise<MeResponse> {
  const { data, error, response } = await api.GET("/auth/me");
  if (error || !data) {
    throw apiError(error, response, "No se pudo cargar el perfil de usuario");
  }
  return data;
}

export async function logout(): Promise<void> {
  const { error, response } = await api.POST("/auth/logout");
  if (error) {
    throw apiError(error, response, "No se pudo cerrar la sesión en el servidor");
  }
}

export const INVALID_CURRENT_PASSWORD_CODE = "InvalidCurrentPasswordError";
export const SAME_PASSWORD_CODE = "SamePasswordError";

export async function changeOwnPassword(
  currentPassword: string,
  newPassword: string,
): Promise<string> {
  const { data, error, response } = await api.POST("/auth/password", {
    body: { current_password: currentPassword, new_password: newPassword },
  });
  if (error || !data) {
    throw apiError(error, response, "No se pudo cambiar la contraseña");
  }
  if (data.status !== "authenticated" || !data.access_token) {
    throw new ApiError("No se pudo cambiar la contraseña", response.status);
  }
  return data.access_token;
}
